import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";

/**
 * Top-level React Router error element. Catches render/loader errors anywhere
 * in the route tree (the SPA replacement for Next's global-error.tsx). A
 * full reload is the simplest recovery path for a hard render failure.
 */
export function ErrorBoundary() {
  const error = useRouteError();

  // Report genuine render/loader crashes to Sentry (no-op if Sentry isn't
  // initialized). Skip route Responses like 404/401 — those are expected
  // control flow, not crashes.
  useEffect(() => {
    if (!isRouteErrorResponse(error)) {
      Sentry.captureException(error);
    }
  }, [error]);

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : "Something went wrong";

  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <h1 className="text-primary text-6xl font-normal">500</h1>
      <p className="text-muted mt-4 text-lg">{message}</p>
      <button
        onClick={() => window.location.reload()}
        className="bg-accent text-accent-foreground hover:bg-accent/90 mt-8 rounded-lg px-6 py-2 text-sm font-medium"
      >
        Try again
      </button>
    </div>
  );
}
